import dayjs, { Dayjs } from 'dayjs'

const isoStringFormat = 'YYYY-MM-DDTHH:mm'

const buildReportingDate = (
  date: Dayjs | null | undefined,
  time: Dayjs | null | undefined,
  anchor: 'start' | 'end'
) => {
  const newDate =
    anchor === 'start' ? dayjs(date).startOf('day') : dayjs(date).endOf('day')
  return dayjs(newDate).format(isoStringFormat)
}

export { buildReportingDate }
